var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui-btn",style:({ width: _vm.width }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.btnText)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }